import React, { CSSProperties, ReactNode } from 'react';
import { CcIcon } from '@utp/components-react';

import IDHelpers from '../../../core/helpers/IDHelper';

import * as S from './styled';

import ReusableTitle from '../Title';

interface IProps {
  children: ReactNode[];
  step: number;
  style?: CSSProperties;
  titles: string[];
}

const ReusableTimeLine = ({ children, step, style, titles }: IProps) => (
  <S.Wrapper style={{ ...style }}>
    {children.map((el, i) => (
      <S.WrapperItem
        active={i === step}
        complete={step > i}
        key={IDHelpers.generateID()}
      >
        <S.WrapperHeader>
          <S.WrapperCircle>
            <CcIcon name="check" size={16} />
            <span>{i + 1}</span>
          </S.WrapperCircle>
          <ReusableTitle
            color={i === step || step > i ? '#5b36f2' : '#8090bb'}
            fontSize="14px"
            fontWeight="700"
            lineHeight="20px"
            title={titles?.[i]}
          />
        </S.WrapperHeader>
        <S.WrapperMain complete={step > i}>{el}</S.WrapperMain>
      </S.WrapperItem>
    ))}
  </S.Wrapper>
);

export default ReusableTimeLine;
